<template>
  <div class="collection-flow-wrap">
    <div class="search">
      <el-form inline class="inline-form" :model="searchForm" label-width="100px" label-position="right">
        <el-form-item label="付款时间">
          <DateTimeRangePicker
            ref="dateRangePicker"
            maxRange="3 month"
            type="daterange"
            :startTime.sync="searchForm.startTime"
            :endTime.sync="searchForm.endTime"
            :shortcutArr="['今天', '昨天', '本周', '本月']"
            @quickSelect="handleQuickSelect"
          />
        </el-form-item>
        <br>
        <el-form-item label="乐刷商户号">
          <el-input v-model="searchForm.merchantId" size="small" clearable placeholder="请输入乐刷商户号"/>
        </el-form-item>
        <el-form-item label="收款单">
          <CommonSelect
            v-model="searchForm.receiptOrderNos"
            :needAll="true"
            :options="collectionList"
            :isMultiple="true"
            :filterable="true"
          />
          <!-- <el-select v-model="searchForm.collection" size="small" clearable filterable placeholder="请选择收款单">
            <el-option label="全部" value="" />
            <el-option
              v-for="(item, index) in collectionList"
              :key="index"
              :value="item.value"
              :label="item.label"
            />
          </el-select> -->
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="searchForm.payType" size="small" clearable filterable placeholder="请选择支付方式">
            <el-option label="全部" value=""/>
            <el-option v-for="(item, key, index) in mapPayWay" :key="index" :value="Number(key)" :label="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="收款订单号">
          <el-input v-model="searchForm.payOrderNo" size="small" clearable placeholder="请输入收款单订单号"/>
        </el-form-item>
        <el-form-item label="交易订单号">
          <el-input v-model="searchForm.lsOrderNo" size="small" clearable placeholder="请输入交易订单号"/>
        </el-form-item>
        <el-form-item label="付款状态">
          <el-select v-model="searchForm.status" size="small" clearable filterable placeholder="请选择付款状态">
            <el-option label="全部" value=""/>
            <el-option v-for="(item, key, index) in mapPayStatus" :key="index" :value="Number(key)" :label="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="交易类型">
          <el-select v-model="searchForm.orderType" size="small" clearable filterable placeholder="请选择交易类型">
            <el-option label="全部" value=""/>
            <el-option v-for="(item, key, index) in mapTransType" :key="index" :value="Number(key)" :label="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="门店">
          <CommonSelect
            v-model="searchForm.targetShopIds"
            :needAll="true"
            :options="shopConfig.options"
            :isMultiple="shopConfig.isMultiple"
            :needPaging="shopConfig.needPaging"
            :pageLoading="shopConfig.pageLoading"
            :filterable="false"
            :clearable="false"
            @loadmore="handleLoadMore(shopConfig.query)"
          />
        </el-form-item>
        <el-button type="primary" size="small" @click="handleSearch" class="btn-base searchBtn bs-btn">查询</el-button>
        <el-button size="small" @click="handleReset" class="btn-base searchBtn bs-btn2">重置</el-button>
        <el-button size="small" @click="handleExport" class="btn-base searchBtn bs-btn" :loading="exportLoading">导出
        </el-button>
      </el-form>
    </div>
    <div class="table-data">
      <el-table
        :data="table.listData"
        style="width: 100%;"
        border
        v-loading="table.loading"
      >
        <template v-for="(column, index) in table.columns">
          <!-- 纯展示列 -->
          <el-table-column
            v-if="!column.special"
            :key="index"
            :label="column.label"
            :prop="column.prop"
            :formatter="column.formatter || ((item) => (item[column.prop]))"
            :min-width="column.minWidth || 120"
            :align="column.align || 'center'"
          ></el-table-column>
          <!-- 特殊列 -->
          <el-table-column
            v-else
            :key="index"
            :label="column.label"
            :width="180"
            :align="column.align || 'center'"
          >
            <template slot-scope="{$index, row}">
              <span v-if="!row.customerInfo || !row.customerInfo.length">-</span>
              <el-tooltip
                v-else
                placement="bottom"
                title="标题"
                width="200"
                trigger="hover"
              >
                <div v-html="customerInfoTxt(row.customerInfo, 2)" style="text-align: left;"></div>
                <div slot="content" v-html="customerInfoTxt(row.customerInfo)"></div>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-col :span="24" class="paginationBox">
        <el-pagination
          v-if="table.count > 0"
          class="pagination"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="table.count"
          :current-page="table.pageNo"
          @current-change="handleCurrentPageChange"
        />
      </el-col>
    </div>
  </div>
</template>

<script>
import DateTimeRangePicker from '@/components/dateTimeRangePicker.vue';
import CommonSelect from '@/components/CommonSelectFilter.vue';
import { getReceiptFlowList, queryReceiptSelectList } from '@/api/collection-bill';
import { queryShopList } from '@/api/flow';
import { downLoadFileByForm } from "@/utils/index";
import { host } from "@/global-config";

export default {
  components: {
    DateTimeRangePicker,
    CommonSelect,
  },
  data() {
    return {
      // 枚举
      mapPayWay: { // 支付方式
        // 0: '未知',
        1: '微信',
        2: '支付宝',
      },
      mapPayStatus: { // 付款状态
        [-1]: '已取消',
        0: '待支付',
        1: '支付成功',
        2: '支付失败',
        3: '已退款',
        4: '退款中',
        5: '退款失败',
      },
      mapTransType: { // 交易类型
        1: '收款',
        2: '退款',
      },
      // 下拉选择项
      collectionList: [],
      searchForm: {
        startTime: '',
        endTime: '',
        merchantId: '',
        payType: '',
        receiptOrderNos: ['all'],
        payOrderNo: '',
        lsOrderNo: '',
        status: '',
        orderType: '',
        targetShopIds: [],
      },
      shopConfig: {
        options: [],
        isMultiple: true,
        needPaging: true,
        pageLoading: false,
        pageNo: 1,
        pageSize: 30,
        finished: false,
        query: 'queryShopList',
      },
      table: {
        loading: false,
        listData: [],
        columns: [
          { label: '订单创建时间', prop: 'createTime' },
          { label: '收款订单号', prop: 'payOrderNo' },
          { label: '交易订单号', prop: 'lsOrderNo' },
          { label: '交易金额', prop: 'tradeAmount', formatter: item => item.tradeAmount / 100 },
          { label: '交易类型', prop: 'orderType', formatter: item => this.mapTransType[item.orderType] },
          { label: '交易状态', prop: 'status', formatter: item => this.mapPayStatus[item.status] },
          { label: '交易时间', prop: 'payTime' },
          { label: '支付方式', prop: 'payType', formatter: item => this.mapPayWay[item.payType] || '未知' },
          { label: '收款单编号', prop: 'receiptOrderNo' },
          { label: '收款单名称', prop: 'receiptName' },
          { label: '顾客信息', prop: 'customerInfo', special: 'popover' },
          { label: '乐刷商户号', prop: 'merchantId' },
          { label: '门店编号', prop: 'shopId' },
          { label: '门店名称', prop: 'merchantName' },
        ],
        pageNo: 1,
        count: 0,
      },
      exportLoading: false, // 导出按钮的loading
    };
  },
  computed: {
    customerInfoTxt() {
      return (remarkList, lineNum) => {
        if (!remarkList.length) return '-';
        return lineNum ? remarkList.slice(0, lineNum).join('<br>') : remarkList.join('<br>');
      };
    },
    loginInfo() {
      return JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
    },
  },
  created() {
    // 获取收款单下拉列表
    queryReceiptSelectList().then((res) => {
      if (String(res.data.error_code) === '0') {
        this.collectionList = res.data.data.map(v => ({
          label: `${v.receiptName}${v.receiptOrderNo}`,
          value: v.receiptOrderNo,
        }));
        console.log('collection list:', this.collectionList);
      } else {
        this.$message.error(res.data.error_msg);
      }
    });
    this.queryShopList();
  },
  methods: {
    handleLoadMore(queryFunc) {
      if (queryFunc) this[queryFunc]();
    },
    queryShopList() {
      const { pageNo, finished, pageSize } = this.shopConfig;
      if (finished) return false;
      this.shopConfig.pageLoading = true;
      queryShopList({ pageNo, pageSize }).then(({ data: { code, data } }) => {
        this.shopConfig.pageLoading = false;
        if (code === '0') {
          const newList = data.list.map(i => ({ label: `${i.shopName} ${i.shopId}`, value: i.shopId }));
          this.shopConfig.options = [...this.shopConfig.options, ...newList];
          if (newList.length < pageSize) {
            this.shopConfig.finished = true;
          } else {
            this.shopConfig.pageNo += 1;
          }
        }
      });
      return true;
    },
    getActualParams() {
      const {
        startTime,
        endTime,
        merchantId,
        receiptOrderNos,
        payType,
        orderType,
        status,
        payOrderNo,
        lsOrderNo,
        targetShopIds,
      } = this.searchForm;
      if ((!payOrderNo && !lsOrderNo) && (!startTime || !endTime)) {
        this.$message.warning('请选择日期范围');
        return false;
      }
      return {
        startTime: `${startTime} 00:00:00`,
        endTime: `${endTime} 23:59:59`,
        merchantId,
        receiptOrderNos: receiptOrderNos.filter(v => v !== 'all'),
        payType,
        orderType,
        status,
        payOrderNo,
        lsOrderNo,
        targetShopIds,
        pageNo: this.table.pageNo,
        pageSize: 10,
      };
    },
    // 搜索
    handleSearch() {
      console.log('searchForm:', this.searchForm);
      // 若两个订单号均为空，日期范围不允许清空
      const params = this.getActualParams();
      if (!params) return;
      this.table.loading = true;
      getReceiptFlowList(params).then((res) => {
        if (String(res.data.error_code) === '0') {
          console.log('000', res.data.data);
          const { list, totalCount } = res.data.data;
          this.table.listData = list;
          this.table.count = totalCount;
          this.table.listData.forEach((v) => {
            const { customerInfo } = v;
            v.customerInfo = customerInfo.map((c) => {
              const title = c.title;
              const value = c.remarkOptionsList.map(r => r.content).join(',');
              return `${title}：${value}`;
            });
          });
        } else {
          this.table.listData = [];
          this.table.count = 0;
          this.table.pageNo = 1;
        }
      }).finally(() => {
        this.table.loading = false;
      });
    },
    // 重置
    handleReset() {
      this.searchForm = this.$options.data().searchForm;
      this.$refs.dateRangePicker.handleQuickTimePickerChange(0);
    },
    // 导出
    handleExport() {
      const params = this.getActualParams();
      if (!params) return;
      const { userName, sessionId } = this.loginInfo;
      const url = `${host}/receipt-order-trans/export?userName=${userName}&sessionId=${sessionId}`;
      // this.exportLoading = true;
      downLoadFileByForm(url, { ...params });
      // exportReceiptFlowList(params).then((res) => {
      //   this.exportLoading = false;
      // });
    },
    // 日期范围快捷选择后立即进行查询
    handleQuickSelect() {
      this.handleSearch();
    },
    handleCurrentPageChange(pageNo) {
      this.table.pageNo = pageNo;
      this.handleSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-flow-wrap {
  .search {
    padding-top: 40px;
    padding-bottom: 20px;
    padding-left: 50px;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .table-data {
    padding: 40px 50px;
    overflow: hidden;
    background-color: #fff;

    .table-btn {
      margin-right: 10px;
      color: #ff9c00;
      cursor: pointer;
    }

    .t-btn {
      color: #1395ff;
    }
  }
}

// .el-select__tags {
//   display: flex;
//   flex-wrap: wrap;
//   // white-space: wrap;
//   // overflow: hidden;
// }
.el-select__input {
  display: block;
  flex-grow: 0 !important;
  width: 100px;
}
</style>
